import { fetchWithAuth } from "../components/fetchWrapper.ts";

import { API_BASE } from "../config/apiBase";

const API = API_BASE;

// Pomocný typ pre request data
export type RequestData = Record<string, unknown>;

export const apiService = {
  // Reports
  getReports: (token: string) =>
    fetchWithAuth(`${API}/reports`, { token }),

  getReport: (token: string, reportId: string | number) =>
    fetchWithAuth(`${API}/reports/${reportId}`, { token }),

  createReport: (token: string, data: RequestData) =>
    fetchWithAuth(`${API}/reports`, {
      method: "POST",
      token,
      body: JSON.stringify(data),
    }),

  updateReport: (token: string, reportId: string, data: RequestData) =>
    fetchWithAuth(`${API}/reports/${reportId}`, {
      method: "PUT",
      token,
      body: JSON.stringify(data),
    }),

  markReportOpened: (token: string, reportId: string) =>
    fetchWithAuth(`${API}/reports/${reportId}/opened`, {
      method: "PUT",
      token,
    }),

  deleteReport: (token: string, reportId: string) =>
    fetchWithAuth(`${API}/reports/${reportId}`, {
      method: "DELETE",
      token,
    }),

  // Customers
  getCustomers: (token: string) =>
    fetchWithAuth(`${API}/customers`, { token }),

  createCustomer: (token: string, data: RequestData) =>
    fetchWithAuth(`${API}/customers`, {
      method: "POST",
      token,
      body: JSON.stringify(data),
    }),

  deleteCustomer: (token: string, customerId: string) =>
    fetchWithAuth(`${API}/customers/${customerId}`, {
      method: "DELETE",
      token,
    }),

  // Folders
  getFolders: (token: string) =>
    fetchWithAuth(`${API}/folders`, { token }),

  createFolder: (token: string, data: RequestData) =>
    fetchWithAuth(`${API}/folders`, {
      method: "POST",
      token,
      body: JSON.stringify(data),
    }),

  updateFolder: (token: string, folderId: string, data: RequestData) =>
    fetchWithAuth(`${API}/folders/${folderId}`, {
      method: "PUT",
      token,
      body: JSON.stringify(data),
    }),

  deleteFolder: (token: string, folderId: string) =>
    fetchWithAuth(`${API}/folders/${folderId}`, {
      method: "DELETE",
      token,
    }),

  // Users
  getUser: (token: string, userId: string) =>
    fetchWithAuth(`${API}/users/${userId}`, { token }),

  // Refresh must bypass fetchWithAuth; otherwise an expired client-side token
  // recursively tries to refresh itself before this request can be sent.
  refreshToken: () =>
    fetch(`${API}/refresh-token`, {
      method: "POST",
      credentials: "include",
    }),

  // Calendar
  getCalendarEvents: (token: string, userId: string) =>
    fetchWithAuth(`${API}/calendar/${userId}`, { token }),

  createCalendarEvent: (token: string, data: RequestData) =>
    fetchWithAuth(`${API}/calendar`, {
      method: "POST",
      token,
      body: JSON.stringify(data),
    }),

  updateCalendarEvent: (token: string, eventId: string, data: RequestData) =>
    fetchWithAuth(`${API}/calendar/${eventId}`, {
      method: "PUT",
      token,
      body: JSON.stringify(data),
    }),

  deleteCalendarEvent: (token: string, eventId: string) =>
    fetchWithAuth(`${API}/calendar/${eventId}`, {
      method: "DELETE",
      token,
    }),

  // Project tasks used by the global quick-action checklist
  getTasks: (token: string) =>
    fetchWithAuth(`${API}/note-items/all`, { token }),

  updateTask: (token: string, itemId: string, data: RequestData) =>
    fetchWithAuth(`${API}/note-items/${itemId}`, {
      method: "PUT",
      token,
      body: JSON.stringify(data),
    }),

  // Profile
  getProfile: (token: string) =>
    fetchWithAuth(`${API}/profile`, { token }),

  updateProfile: (token: string, data: RequestData) =>
    fetchWithAuth(`${API}/profile`, {
      method: "PUT",
      token,
      body: JSON.stringify(data),
    }),
  getIdokladInvoices: (token: string, from: string, to: string) =>
    fetchWithAuth(
      `${API}/integrations/idoklad/invoices?from=${from}&to=${to}`,
      { token }
    ),
};
